import React, { FunctionComponent } from 'react';

import { Image } from 'src/components/image';

export enum SourceType {
  WEBP = 'image/webp',
}

interface Source {
  type: SourceType;
  src: string;
}

export interface PictureProps {
  defaultSrc: string;
  alt: string;
  sources: Source[];
}

export const Picture: FunctionComponent<PictureProps> = (props) => {
  const { defaultSrc, sources, ...rest } = props;

  return (
    <picture>
      {sources.map((source, index) => (
        <source key={index} src={source.src} type={source.type} />
      ))}
      <Image {...rest} src={defaultSrc} />
    </picture>
  );
};
